const People = ({ className = "", color }: { className?: string; color: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <circle data-name="layer2" cx="13.998" cy="11" r="6" fill={color} opacity=".65"></circle>
    <path
      data-name="layer2"
      d="M23 25h3.305L26 24a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h3v13a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V28a3 3 0 0 1 3-3z"
      fill={color}
      opacity=".65"
    ></path>
    <circle data-name="layer2" cx="49.998" cy="11" r="6" fill={color} opacity=".65"></circle>
    <path
      data-name="layer2"
      d="M59 21H41a3 3 0 0 0-3 3v1h3a3 3 0 0 1 3 3v26a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V41h3a3 3 0 0 0 3-3V24a3 3 0 0 0-3-3z"
      fill={color}
      opacity=".65"
    ></path>
    <circle data-name="layer1" cx="32" cy="15.004" r="6" fill={color}></circle>
    <path
      data-name="layer1"
      d="M41 25H23a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h3v13a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V45h3a3 3 0 0 0 3-3V28a3 3 0 0 0-3-3z"
      fill={color}
    ></path>
    <path
      data-name="opacity"
      d="M32 25h-9a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h3v13a3 3 0 0 0 3 3h3zm0-16a6 6 0 1 0 0 12z"
      fill="#000064"
      opacity=".15"
    ></path>
  </svg>
);

export default People;
